import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

// asstes
import Avatar from '../../../../assets/customSVG/Avatar';

import Assign from '../../../../assets/customSVG/inbox/Assign';
import Favourite from '../../../../assets/customSVG/inbox/Favourite';
import Resolved from '../../../../assets/customSVG/inbox/Resolved';
import InboxThreeDot from '../../../../assets/customSVG/inbox/InboxThreeDot';
import MarkUnread from '../../../../assets/customSVG/inbox/MarkUnread';
import { ICONS } from '../../../../assets/icons';
import { images } from '../../../../assets/images/index';
import 'draft-js/dist/Draft.css';

// utils
import { Popover, Tooltip, Switch } from 'antd';

// contents
import {
  FEATURE_FLAG_ADD_TO_STAR,
  FEATURE_FLAG_MANUALLY_CLOSE_CONVERSATION,
} from '../../constants/FeatureFlag';

// hooks
import useToggle from '../../../../hooks/useToggle';

// components
import ConversationClose from './ConversationClose';
import ConversationStar from './ConversationStar';
import MessageInput from './MessageInput';
import { formatInternationalPhone } from '../../helper';

// redux
import ListViewSearch from '../../../../components/commonComponents/ListViewHeader/ListViewSearch';
import RadioButton from '../../../../components/form/radio/RadioButton';
import { getRandomColorsBassedOnLetters } from '../../../../helper/colors';
import ConversationTabs from './ConversationTabs';
import { updateAgentEngagementStatus } from '../../api/Api';

export default function ConversationContainer(props) {
  const {
    loading,
    selectedConversationType,
    selectedPhoneNumber,
    selectedPerson,
    conversation,
    getConversations,
    onConversationStarChange,
    onCloseConversation,
    favorite,
    onFavoriteClick,
    onResolvedClick,
    openTemplateList,
    setOpenTemplateList,
    lastReplied,
    conversationList,
    selectedData,
    setSelectedData,
    onAssignClick,
    assignOpen,
    setAssignOpen,
    assignGetData,
    handleAssign,
    setMembersTrue,
    isSideNavOpen,
    activeTabItem,
    onMarkUnread,
    setChatToggle,
    chatToggle,
    getAttachments,
    attachmentFilter,
    getNotes,
    isFetchingPage,
    setIsFetchingPage,
    setConversationPage,
    totalMessageCount,
    newMessageIds,
    setNewMessageIds,
    contactPersondata,
  } = props;

  const { currentBrand, featureFlags } = useSelector((state) => state.app);
  const conversationType = selectedConversationType
    ?.filter((item) => item?.isSelected === true)
    ?.map((item) => item.type);

  const conversationRef = useRef();
  const bottomRef = useRef();

  const [showList, setShowList] = useToggle(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [agentEngagementLoading, setAgentEngagementLoading] = useState(false);

  // Media files
  const [isUploading, setIsUploading] = useToggle(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (!loading) {
      scrollingBottom(500);
    }
  }, [loading]);

  //note
  const handleChat = () => {
    setChatToggle(!chatToggle);
  };

  // constants
  const list = [];
  const name =
    selectedPerson?.first_name && selectedPerson?.last_name
      ? `${selectedPerson?.first_name} ${selectedPerson?.last_name}`
      : selectedPerson?.first_name !== 'UNKNOWN'
      ? selectedPerson?.first_name
      : selectedPerson?.last_name
      ? selectedPerson?.last_name
      : selectedPerson?.first_name === 'UNKNOWN'
      ? selectedPerson?.profile_name
      : selectedPerson?.profile_name && selectedPerson?.profile_name;

  const formatToIndianPhone = (phone) => {
    if (phone?.length !== 12) return 'Invalid phone number';
    return `+${phone?.slice(0, 2)} ${phone?.slice(2, 5)} ${phone?.slice(
      5,
      8,
    )} ${phone?.slice(8, 12)}`;
  };

  const formattedNumber = formatInternationalPhone(
    selectedPerson?.phone_country_code + selectedPerson?.to_number,
  );

  const item = conversationList?.find(
    (item) => item?.id === selectedPerson?.id && item,
  );

  // method to updated agent engagement status
  const setAgentEngagementStatus = async (status) => {
    try {
      setAgentEngagementLoading(true);
      const response = await updateAgentEngagementStatus({
        brand_id: currentBrand?.brand_id,
        contact_conversation_id: selectedPerson?.id,
        agent_engagement_status: status,
      });

      if (response?.status == 200) {
        item.agent_engagement_status = response.data.agent_engagement_status;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAgentEngagementLoading(false);
    }

    console.log({ item });
  };

  // console.log("item", item)

  function isWithin10Minutes(dateTimeUtc) {
    const utcDate = new Date(dateTimeUtc);
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(utcDate.getTime() + istOffset);
    const nowUtc = new Date();
    const nowIst = new Date(nowUtc.getTime() + istOffset);
    const timeDifference = nowIst - istDate;

    return timeDifference >= 0 && timeDifference < 10 * 60 * 1000;
  }

  // Example usage:
  const dateTimeUtc = lastReplied;

  const onlineCheck = isWithin10Minutes(dateTimeUtc);

  const isChatResolved = item?.resolve_status === false;

  const date = new Date(lastReplied);

  const formattedDate = date.toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  const scrollingBottom = (timeout = 100) => {
    setTimeout(() => {
      bottomRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'end',
      });
    }, timeout);
  };

  const getData = (data) => {
    setShowList(true);
    setSelectedMessage(data);
  };

  const [searchKey, setSearchKey] = useState('');

  const handleSearch = (value) => {
    setSearchKey(value);
  };
  const filteredassignGetData = assignGetData.filter((data) =>
    data?.user_name?.toLowerCase().includes(searchKey.toLowerCase()),
  );

  const assignedList = assignGetData.filter((data) => data?.assigned === true);

  return (
    <div
      className={`p-0 overflow-hidden h-[100vh] flex flex-1 flex-col`}
      // ${ isSideNavOpen ? "w-[450px]" : "w-[750px]" }
      style={{
        background: `url(${images?.conversation_bg}) no-repeat`,
        // width: "100%",
      }}
    >
      <div className="flex items-center justify-between gap-[0.8vw] p-[1vw] border-b-[0.08vw] border-[var(--border-50)] bg-white shadow-[0px_1.5px_2px_0px_#1018281A] !z-50">
        <div className="w-100 flex items-center space-between gap-[0.8vw]">
          <div className=" flex-row align-center  gap-2">
            <div className="relative top-0 left-0">
              <div className="size-[2.18vw] rounded-full flex items-center justify-center font-largest weight-medium">
                <Avatar color="#ffffff" />
              </div>
              <span
                className={`w-[15px] h-[15px] border-[0.2vw] border-[var(--white)] rounded-full z-20 absolute -bottom-[0vw] -right-[0.1vw] ${
                  onlineCheck ? 'bg-[#00AA3A]' : 'bg-[#8796AF]'
                }`}
              ></span>
            </div>

            <div className="">
              <p className="text-[0.95vw] font-[500] text-[var(--textBlack)] capitalize">
                {name ?? selectedPerson?.to_number}
              </p>
              {!onlineCheck ? (
                <p className="w-full font-[400] text-[0.7vw] text-[#6B7280]">
                  Last replied {formattedDate}
                </p>
              ) : (
                <span className="text-[0.75vw] font-[400] text-[var(--primary)]">
                  Online
                </span>
              )}
            </div>
          </div>
          <div
            className={`  ${
              isSideNavOpen ? 'flex-column' : 'flex-row align-center'
            }`}
          >
            <div
              className={`w-80 border border-[--border-input] p-[8px] b-radius-6 popover-title  ${
                !isSideNavOpen ? ' mr-[15px]' : 'ml-40 mb-10'
              }`}
            >
              <p className="w-100 text-[0.9rem] font-[500] text-[var(--textBlack)] flex-row align-center gap-2">
                <img src={ICONS?.whatsappInbox} alt="whatsappInbox" />+{' '}
                {formattedNumber}
              </p>
            </div>
            <div
              className={`flex-row align-center gap-5 ps-7  inbox-conversation-header ${
                isSideNavOpen ? '' : 'border-l-[1px]'
              }`}
            >
              {featureFlags?.rag_whatsapp_chat_system && (
                <div className="pe-5">
                  <Switch
                    loading={agentEngagementLoading}
                    checked={item.agent_engagement_status}
                    onChange={(checked) => setAgentEngagementStatus(checked)}
                  />
                </div>
              )}
              <div className="w-[60px]">
                <Popover
                  trigger="click"
                  open={assignOpen}
                  overlayClassName="w-[17vw]"
                  onOpenChange={(open) => setAssignOpen(open)}
                  content={
                    <div className="pointer p-[1px]">
                      <div className="search-container flex-row align-center  mt-10">
                        <ListViewSearch
                          searchingText={(text) => handleSearch(text)}
                        />
                      </div>
                      <div className="border border-[var(--border-input)] rounded-[4px] m-10">
                        {filteredassignGetData?.map((item) => {
                          const firstLetter =
                            item?.user_name?.slice(0, 1).toUpperCase() || '';
                          const colors =
                            getRandomColorsBassedOnLetters(firstLetter);
                          return (
                            <div
                              className={`font14px-600 prl-5 m-5 text-[#3B3F46] flex-row align-center space-between  b-radius-6 ${
                                item?.assigned
                                  ? 'bg-[var(--BG-50)]'
                                  : 'hover:bg-[var(--BG-50)]'
                              }`}
                              onClick={() => {
                                handleAssign(item);
                              }}
                            >
                              <div className="flex-row align-center capitalize">
                                {item?.profile_photo ? (
                                  <div className="relative">
                                    <div className="rounded-full flex items-center justify-center font-largest font-medium">
                                      <img
                                        src={item?.profile_photo}
                                        alt="User Profile Picture"
                                        className="rounded-full w-[1.5rem] h-[1.5rem] object-cover ml-1"
                                      />
                                    </div>
                                    <span
                                      className={`w-[0.65rem] h-[0.65rem] border-2 border-white rounded-full z-20 absolute bottom-0 right-0 ${
                                        item?.status === 10
                                          ? 'bg-[#00AA3A]'
                                          : 'bg-[#8796AF]'
                                      }`}
                                    ></span>
                                  </div>
                                ) : (
                                  <div className="relative">
                                    <div className="rounded-full flex items-center justify-center font-largest font-medium">
                                      <span
                                        className="w-[1.65rem] h-[1.65rem] rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                                        style={{
                                          color: 'white',
                                          backgroundColor:
                                            getRandomColorsBassedOnLetters(
                                              item.user_name
                                                ?.slice(0, 1)
                                                .toUpperCase(),
                                              1.5,
                                            ).backgroundColor,
                                        }}
                                      >
                                        {item.user_name
                                          ?.slice(0, 1)
                                          .toUpperCase()}
                                      </span>
                                    </div>
                                    <span
                                      className={`w-[0.65rem] h-[0.65rem] border-2 border-white rounded-full z-20 absolute bottom-0 right-0 ${
                                        item?.status === 10
                                          ? 'bg-[#00AA3A]'
                                          : 'bg-[#8796AF]'
                                      }`}
                                    ></span>
                                  </div>
                                )}
                                <span className="p-10">
                                  {item?.user_name?.length > 15 ? (
                                    <Tooltip title={item?.user_name}>
                                      {item?.user_name.slice(0, 15) + '...'}
                                    </Tooltip>
                                  ) : (
                                    item?.user_name
                                  )}
                                </span>
                              </div>
                              {item?.assigned && (
                                <div className="w-5 h-9 flex items-center justify-end mt-1 pr-5">
                                  <RadioButton
                                    value={item?.assigned}
                                    selected={item?.assigned}
                                    // onChange={(e) => {}}
                                    // rootClassName={
                                    //   item?.assigned && "size-3 new-radio"
                                    // }
                                  />
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  }
                  arrow={false}
                >
                  <div
                    className={`flex-column align-center pointer justify-center pl-5 ${
                      favorite === selectedPerson?.id ||
                      selectedPerson?.is_favourite === true
                        ? ''
                        : ''
                    }`}
                    onClick={() => onAssignClick(selectedPerson)}
                  >
                    <div className="">
                      <div
                        className={` border-[1.5px] p-[1.5px] border-[#8796AF] rounded-full ${
                          assignedList.length > 0 ? 'absolute' : ''
                        }`}
                      >
                        <Assign
                          color={
                            favorite === selectedPerson?.id ||
                            selectedPerson?.is_favourite
                              ? 'var(--a)'
                              : 'var(--font-600)'
                          }
                          applyFill={
                            (favorite === selectedPerson?.id ||
                              selectedPerson?.is_favourite) ??
                            'var(--a)'
                          }
                        />
                      </div>
                      {assignedList.length > 0 && (
                        <Tooltip
                          title={
                            <div className="flex-column p-5">
                              {assignedList?.map((item) => (
                                <div className="flex-row align-center ptb-5 gap-2 capitalize">
                                  <div className="relative">
                                    {item?.profile_photo ? (
                                      <img
                                        src={item.profile_photo}
                                        alt=""
                                        className="w-5 h-5 rounded-full border-1 border-white"
                                      />
                                    ) : (
                                      <span
                                        className="w-5 h-5 rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                                        style={{
                                          color: 'white',
                                          backgroundColor:
                                            getRandomColorsBassedOnLetters(
                                              item.user_name
                                                ?.slice(0, 1)
                                                .toUpperCase(),
                                              1.5,
                                            ).backgroundColor,
                                        }}
                                      >
                                        {item.user_name
                                          ?.slice(0, 1)
                                          .toUpperCase()}
                                      </span>
                                    )}
                                    <span
                                      className={`w-[0.65rem] h-[0.65rem] border-2 border-white rounded-full z-20 absolute bottom-0 right-0 ${
                                        item?.status === 10
                                          ? 'bg-[#00AA3A]'
                                          : 'bg-[#8796AF]'
                                      }`}
                                    ></span>
                                  </div>
                                  {item?.user_name}
                                </div>
                              ))}
                            </div>
                          }
                          arrow={false}
                        >
                          <div
                            className={`relative  flex  -space-x-1 ${
                              assignedList?.length > 1 ? '-ml-[3rem]' : '-ml-6'
                            }`}
                          >
                            {assignedList?.length > 1 && (
                              <div className="relative">
                                <span className="w-[1.8rem] h-[1.8rem] rounded-full bg-gray-100 text-gray-600 text-[0.65rem] font-[600] flex items-center justify-center border-1 border-white">
                                  +{assignedList?.length - 1}
                                </span>
                              </div>
                            )}
                            {assignedList.slice(0, 1).map((user, index) => (
                              <div
                                key={index}
                                className="relative"
                                style={{ zIndex: 10 - index }}
                              >
                                {user?.profile_photo ? (
                                  <img
                                    src={user.profile_photo}
                                    alt=""
                                    className="w-[1.75rem] h-[1.75rem] rounded-full border-1 border-white"
                                  />
                                ) : (
                                  <span
                                    className="w-[1.8rem] h-[1.8rem] rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                                    style={{
                                      color: 'white',
                                      backgroundColor:
                                        getRandomColorsBassedOnLetters(
                                          user.user_name
                                            ?.slice(0, 1)
                                            .toUpperCase(),
                                          1.5,
                                        ).backgroundColor,
                                    }}
                                  >
                                    {user.user_name?.slice(0, 1).toUpperCase()}
                                  </span>
                                )}
                                <span
                                  className={`w-3 h-3 border-2 border-white rounded-full z-20 top-[18px] absolute bottom-0 right-0 ${
                                    item?.status === 10
                                      ? 'bg-[#00AA3A]'
                                      : 'bg-[#8796AF]'
                                  }`}
                                ></span>
                              </div>
                            ))}
                          </div>
                        </Tooltip>
                      )}
                    </div>
                    <span className="">Assign</span>
                  </div>
                </Popover>
              </div>
              <div
                className={`flex-column align-center gap-1 pl-10- pointer ${
                  favorite === selectedPerson?.id ||
                  selectedPerson?.is_favourite === true
                    ? ''
                    : ''
                }`}
                onClick={() => onFavoriteClick(selectedPerson)}
              >
                <Favourite
                  color={
                    favorite === selectedPerson?.id ||
                    selectedPerson?.is_favourite === true
                      ? 'var(--a)'
                      : 'var(--font-600)'
                  }
                  applyFill={
                    (favorite === selectedPerson?.id ||
                      selectedPerson?.is_favourite === true) ??
                    'var(--a)'
                  }
                />
                Favorite
              </div>
              <div
                className={`flex-column align-center gap-1 pointer ${
                  isChatResolved ? 'text-[var(--TextPrimary)]' : ''
                }`}
                onClick={() => {
                  onResolvedClick(selectedPerson);
                }}
              >
                {isChatResolved ? (
                  <RadioButton selected={true} />
                ) : (
                  <Resolved
                    color={'var(--font-600)'}
                    lineColor={'var(--font-600)'}
                  />
                )}
                Resolved
              </div>
              {/* options popover */}
              <Popover
                className={`flex-column align-center gap-1 pointer`}
                content={
                  <div className="flex-column gap-2 p-1">
                    {/* favorite */}
                    <div
                      className={`flex-row align-center gap-3 pointer p-1 hover:bg-slate-100 rounded-md ${
                        favorite === selectedPerson?.id ||
                        selectedPerson?.is_favourite === true
                          ? ''
                          : ''
                      }`}
                      onClick={() => onFavoriteClick(selectedPerson)}
                    >
                      <Favourite
                        color={
                          favorite === selectedPerson?.id ||
                          selectedPerson?.is_favourite === true
                            ? 'var(--a)'
                            : 'var(--font-600)'
                        }
                        applyFill={
                          (favorite === selectedPerson?.id ||
                            selectedPerson?.is_favourite === true) ??
                          'var(--a)'
                        }
                      />
                      Favorite
                    </div>
                    {/* resolved */}
                    <div
                      className={`flex-row align-center gap-3 pointer p-1 hover:bg-slate-100 rounded-md ${
                        isChatResolved ? 'text-[var(--TextPrimary)]' : ''
                      }`}
                      onClick={() => {
                        onResolvedClick(selectedPerson);
                      }}
                    >
                      {isChatResolved ? (
                        <RadioButton selected={true} />
                      ) : (
                        <Resolved
                          color={'var(--font-600)'}
                          lineColor={'var(--font-600)'}
                        />
                      )}
                      Resolved
                    </div>
                    {/* mark as unread */}
                    <div
                      className={`flex-row align-center gap-3 pointer p-1 hover:bg-slate-100 rounded-md`}
                      onClick={() => {
                        onMarkUnread(selectedPerson);
                      }}
                    >
                      {<MarkUnread />}
                      Mark as unread
                    </div>
                  </div>
                }
                trigger="click"
              >
                <span className="flex-column align-center gap-1 pointer">
                  <div className={`flex-column align-center gap-1 pointer`}>
                    <InboxThreeDot
                      color={'var(--font-600)'}
                      lineColor={'var(--font-600)'}
                    />
                    More
                  </div>
                </span>
              </Popover>
            </div>
          </div>
        </div>
        {(FEATURE_FLAG_MANUALLY_CLOSE_CONVERSATION ||
          FEATURE_FLAG_ADD_TO_STAR) && (
          <div className="w-fit flex items-center gap-[0.8vw]">
            {FEATURE_FLAG_MANUALLY_CLOSE_CONVERSATION && (
              <ConversationClose
                className={'w-[0.95vw] h-[0.95vw]'}
                onChange={onCloseConversation}
                data={selectedPerson}
              />
            )}
            {FEATURE_FLAG_ADD_TO_STAR && (
              <ConversationStar
                data={selectedPerson}
                width={'0.95vw'}
                height={'0.95vw'}
                onChange={onConversationStarChange}
              />
            )}
          </div>
        )}
      </div>

      <ConversationTabs
        loading={loading}
        conversation={conversation}
        conversationType={conversationType}
        conversationRef={conversationRef}
        selectedFile={selectedFile}
        isUploading={isUploading}
        selectedData={selectedData}
        isSideNavOpen={isSideNavOpen}
        setSelectedData={setSelectedData}
        isChatResolved={isChatResolved}
        getData={getData}
        bottomRef={bottomRef}
        isFetchingPage={isFetchingPage}
        setIsFetchingPage={setIsFetchingPage}
        setConversationPage={setConversationPage}
        totalMessageCount={totalMessageCount}
        scrollingBottom={scrollingBottom}
        newMessageIds={newMessageIds}
        setNewMessageIds={setNewMessageIds}
        selectedPerson={selectedPerson}
      />

      <MessageInput
        activeTabItem={activeTabItem}
        selectedPhoneNumber={selectedPhoneNumber}
        selectedPerson={selectedPerson}
        conversationType={conversationType}
        isChatResolved={isChatResolved}
        chatToggle={chatToggle}
        selectedData={selectedData}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        isUploading={isUploading}
        setIsUploading={setIsUploading}
        handleChat={handleChat}
        showList={showList}
        setShowList={setShowList}
        openTemplateList={openTemplateList}
        setOpenTemplateList={setOpenTemplateList}
        assignGetData={assignGetData}
        getAttachments={getAttachments}
        attachmentFilter={attachmentFilter}
        setMembersTrue={setMembersTrue}
        getConversations={getConversations}
        scrollingBottom={scrollingBottom}
        selectedMessage={selectedMessage}
        setSelectedMessage={setSelectedMessage}
        setSelectedData={setSelectedData}
        item={item}
        getNotes={getNotes}
      />
    </div>
  );
}
